<template>
  <div class="policy-page">
    <WeCircularNavbar @go-home="$emit('go-home')" @go-countries="$emit('go-countries')" />

    <main class="policy-page__container">
      <button class="back-button" type="button" @click="$router.back()">
        ← Back
      </button>

      <section class="policy-hero">
        <div class="policy-hero__content">
          <h1 class="policy-title">
            European Policies and Strategies
          </h1>

          <h2 class="policy-subtitle">
            Smart Specialization Strategies
          </h2>

          <p class="policy-intro">
            Smart Specialisation Strategies foster knowledge-based growth in EU regions and countries. They are crucial
            to achieving a smarter, sustainable and inclusive Europe.
          </p>
        </div>
      </section>

      <section class="s3-panel">
        <div class="s3-panel__overlay"></div>

        <div class="s3-panel__content">
          <article v-for="(item, index) in s3Links" :key="'s3-link-' + index" class="s3-item">
            <a :href="item.url" target="_blank" rel="noopener noreferrer" class="s3-link">
              <span class="s3-link__text">
                {{ item.title }}
              </span>

              <span
                class="s3-link__icon"
                :class="{ 's3-link__icon--download': item.type === 'pdf' }"
                aria-hidden="true"
              >
                <template v-if="item.type === 'pdf'">
                  <span class="s3-link__icon">
                    <img :src="item.type === 'pdf' ? downloadIcon : arrowIcon" alt="" />
                  </span>
                </template>
                <template v-else>→</template>
              </span>
            </a>
          </article>
        </div>
      </section>
    </main>

    <WeCircularFooter />
  </div>
</template>

<script>
import WeCircularNavbar from './WeCircularNavbar.vue'
import WeCircularFooter from './WeCircularFooter.vue'
import downloadIcon from '../../assets/img/we-circular/download_1.svg'
import arrowIcon from '../../assets/img/we-circular/arrow_2.svg'

export default {
  name: 'SmartSpecialisationStrategiesPage',
  components: {
    WeCircularNavbar,
    WeCircularFooter
  },
  emits: ['go-home', 'go-countries'],
  data() {
    return {
      downloadIcon,
      arrowIcon,
      s3Links: [
        {
          title: 'Good Governance of National or Regional Smart Specialisation Strategy',
          url: 'https://ec.europa.eu/regional_policy/policy/communities-and-networks/s3-community-of-practice/about_en',
          type: 'link'
        },
        {
          title: 'The Smart Specialisation Policy Experience: Perspective of National and Regional Authorities',
          url: 'https://publications.jrc.ec.europa.eu/repository/handle/JRC123918',
          type: 'link'
        },
        {
          title: 'The role of the Smart Specialisation in the cohesion policy 2021-2027',
          url:
            'https://ec.europa.eu/regional_policy/sources/policy/communities-and-networks/s3-community-of-practice/The_role_of_the_Smart_Specialisation_in_the_cohesion_policy_2021_2027.pdf',
          type: 'pdf'
        },
        {
          title: 'Analysis of key parameters of Smart Specialisation Strategies (S3)',
          url:
            'https://ec.europa.eu/regional_policy/sources/policy/communities-and-networks/s3-community-of-practice/Analysis_of_key_parameters_of_Smart_Specialisation_Strategies_(S3).pdf',
          type: 'pdf'
        },
        {
          title: 'Study on prioritisation in Smart Specialisation Strategies in the EU',
          url:
            'https://ec.europa.eu/regional_policy/sources/policy/communities-and-networks/s3-community-of-practice/Study_on_prioritisation_in_Smart_Specialisation_Strategies_in_the_EU.pdf',
          type: 'pdf'
        }
      ]
    }
  }
}
</script>

<style scoped>
.policy-page {
  min-height: 100vh;
  background: #f3f3f3;
  padding: 22px 0 64px;
}

.policy-page__container {
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 38px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 5vw;
}

.back-button {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  align-self: flex-start;
  height: 30px;
  min-width: 66px;
  padding: 0 12px;
  margin: 0 0 22px 0;
  border: 1px solid #003399;
  border-radius: 8px;
  background: transparent;
  color: #003399;
  font-size: 13px;
  line-height: 1;
  cursor: pointer;
}

.policy-hero {
  width: 100%;
  margin-bottom: 28px;
}

.policy-hero__content {
  width: 100%;
  max-width: 720px;
  text-align: left;
}

.policy-title {
  margin: 0;
  max-width: 760px;
  color: #003399;
  font-size: 54px;
  line-height: 1.02;
  font-weight: 600;
  letter-spacing: -0.03em;
  text-align: left;
}

.policy-subtitle {
  margin: 28px 0 0;
  color: #003399;
  font-size: 30px;
  line-height: 1.08;
  font-weight: 600;
  text-align: left;
}

.policy-intro {
  max-width: 360px;
  margin: 14px 0 0;
  color: #0e6eb6;
  font-size: 14px;
  line-height: 1.5;
  text-align: left;
}

.s3-panel {
  position: relative;
  width: 100%;
  max-width: 1120px;
  min-height: 180px;
  border-radius: 16px;
  overflow: hidden;
  background: #004f4f;
  background-image: url('../../assets/img/we-circular/9-16@4x.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 34px 52px 30px;
  box-sizing: border-box;
}

.s3-panel__overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 79, 79, 0.24);
  pointer-events: none;
}

.s3-panel__content {
  position: relative;
  z-index: 1;
  max-width: 720px;
}

.s3-item + .s3-item {
  margin-top: 10px;
}

.s3-link {
  display: grid;
  grid-template-columns: 1fr 22px;
  align-items: center;
  gap: 16px;
  color: #ffffff;
  text-decoration: none;
}

.s3-link:hover .s3-link__text {
  text-decoration: underline;
}

.s3-link__text {
  display: block;
  color: #ffffff;
  font-size: 14px;
  line-height: 1.5;
  text-align: left;
}

.s3-link__icon {
  width: 24px;
  height: 24px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #005ed9;
  color: #ffffff;
  font-size: 10px;
  line-height: 1;
  flex-shrink: 0;
}

.s3-link__icon--download {
  font-size: 9px;
}

@media (max-width: 1100px) {
  .policy-page__container {
    max-width: 92%;
    padding: 0 20px;
  }

  .s3-panel {
    padding: 28px 24px 24px;
  }
}

@media (max-width: 900px) {
  .policy-title {
    font-size: 34px;
  }

  .policy-subtitle {
    font-size: 24px;
  }

  .policy-intro {
    max-width: 100%;
  }

  .s3-panel {
    min-height: auto;
  }

  .s3-panel__content {
    max-width: 100%;
  }
}

@media (max-width: 480px) {
  .policy-page {
    padding-bottom: 48px;
  }

  .policy-title {
    font-size: 26px;
  }

  .policy-subtitle {
    font-size: 20px;
  }

  .policy-intro {
    font-size: 12px;
  }

  .s3-panel {
    padding: 22px 16px 18px;
    border-radius: 12px;
  }

  .s3-link {
    grid-template-columns: 1fr 18px;
    gap: 10px;
  }

  .s3-link__text {
    font-size: 12px;
  }

  .s3-link__icon {
    width: 14px;
    height: 14px;
    font-size: 9px;
  }
}
</style>
